@if (image) {
    <sirius-avatar
        class="sir-author-image"
        [image]="image"
        size="xxl"
        itemprop="image"
        data-cy="author-image"></sirius-avatar>
}

<div class="sir-author-profile" data-cy="author-profile">
    <header>
        <sirius-heading
            [h]="3"
            [text]="name"
            textStyleSize="s"
            itemprop="name"
            data-cy="author-name"></sirius-heading>

        @if (jobTitle) {
            <span
                class="sir-text-style-paragraph-s-bold sir-author-job-title"
                itemprop="jobTitle"
                data-cy="author-job-title"
                >{{ jobTitle }}</span
            >
        }
    </header>

    <sirius-text-html
        [html]="descriptionHtml"
        textStyleSize="m"
        itemprop="description"
        data-cy="author-description"></sirius-text-html>

    @if (linkedInLink) {
        <footer>
            <a
                siriusButton
                [siriusLink]="linkedInLink"
                [buttonText]="linkedInLink.title"
                buttonType="primary"
                iconName="linkedin_logo_duotone"
                iconPos="left"
                size="small"
                itemprop="sameAs"
                data-cy="author-linkedin">
            </a>
        </footer>
    }
</div>
